<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="true"
    [title]="'Edit Client'"
    [showLinkIcon]="true"
    [linkIcon]="'trash'"
    (linkAction)="confirmDeleteClient()">
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>

    <tidy-card *ngIf="loaded">
      <form [formGroup]="form">
        <tidy-row class="field-bottom-padding field-top-padding">
          <tidy-input
            [label]="'First Name *'"
            formControlName="firstName"
            data-cy="firstName"
            [form]="form.controls.firstName"
            [icon]="'assets/svg/person-circle-outline.svg'"
            [activeIcon]="'assets/svg/person-circle-outline-tidy-green.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter the client\'s first name'">
          </tidy-input>
        </tidy-row>
        <tidy-row class="field-bottom-padding">
          <tidy-input
            [label]="'Last Name *'"
            formControlName="lastName"
            data-cy="lastName"
            [form]="form.controls.lastName"
            [icon]="'assets/svg/person-circle-outline.svg'"
            [activeIcon]="'assets/svg/person-circle-outline-tidy-green.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter the client\'s last name'">
          </tidy-input>
        </tidy-row>
        <tidy-row class="field-bottom-padding">
          <tidy-input
            [label]="'Email'"
            formControlName="email"
            data-cy="email"
            type="email"
            [form]="form.controls.email"
            [icon]="'assets/svg/mail-outline.svg'"
            [activeIcon]="'assets/svg/mail-outline-tidy-green.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter a valid email'">
          </tidy-input>
        </tidy-row>
        <tidy-row>
          <tidy-input-international-phone
            formControlName="phone"
            [label]="'Phone Number'"
            data-cy="phone"
            [form]="form.controls.phone"
            [inputMode]="'numeric'"
            [submitted]="submitted"
            [errorMessage]="'Please enter a valid phone number.'"
            [icon]="'assets/svg/phone-portrait-outline.svg'"
            [defaultCountryCode]="proCountryCode"
            [activeIcon]="'assets/svg/phone-portrait-outline-tidy-green.svg'"
            [initialMask]="proCountryCode || 'US'">
          </tidy-input-international-phone>
        </tidy-row>
      </form>
    </tidy-card>

    <tidy-error-message
      *ngIf="errorMessage"
      [text]="errorMessage">
    </tidy-error-message>

    <tidy-button
      [text]="'Save Changes'"
      data-cy="btn-saveChanges"
      [action]="saveChanges.bind(this)"
      class="primary">
    </tidy-button>
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>
